import styled from "styled-components";

export const MainList = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    max-width: 1320px;
    margin: 0 auto;
`
export const DivDate = styled.div`
    font-weight: bold;
    padding: 20px;
    font-size: 36px;
`

export const ContainerList = styled.div`
    padding: 20px;
    margin-top: 10px;
    font-size: 23px;
    max-width: 890px;
`
export const ContainerInfo = styled.div`
    display: inline-block;
    background-color: #c3d7c8;
    padding: 4px;
    font-size: 26px;
    font-weight: bold;
    border: 2px solid #387c4a;
    border-radius: 3px;
    margin-top: 10px;
    min-width: 220px;
    text-align: center;
`